import teams from './mockSportData';

const sports = [
  {
    name: 'americanFootball',
    icon: 'americanFootball',
    teamSport: true,
    teams: teams.americanFootball,
    positions: [
      'cornerback',
      'safety',
      'leftGuard',
      'rightGuard',
      'center',
      'leftTackle',
      'rightTackle',
      'noseTackle',
      'middleLineBacker',
      'outsideLineBacker',
      'defensiveEnd',
      'defensiveTackles',
      'wideReceiver',
      'offensiveTackles',
      'offensiveLineman',
      'tightEnd',
      'quarterback',
      'runningBack',
      'runningBackHalfback',
      'runningBackFullback',
      'defensiveBack',
      'flanker',
      'splitEnd',
      'kicker',
      'punter'
    ]
  },
  {
    name: 'baseball',
    icon: 'baseball',
    teamSport: true,
    teams: [],
    positions: [
      'centerFielder',
      'leftFielder',
      'rightFielder',
      'shortstop',
      'firstBaseman',
      'secondBaseman',
      'thirdBaseman',
      'pitcher',
      'designatedHitter',
      'catcher'
    ]
  },
  {
    name: 'basketball',
    icon: 'basketball',
    teamSport: true,
    teams: teams.basketball,
    positions: [
      'pointGuard',
      'shootingGuard',
      'smallForward',
      'powerForward',
      'center',
      'comboGuard',
      'wingGuard',
      'pointForward',
      'comboForward'
    ]
  },
  {
    name: 'boxing',
    icon: 'boxing',
    players: ['Tyson Fury', 'Lawrence Okolie', 'Artur Beterbiev']
  },
  {
    name: 'cricket',
    icon: 'cricket',
    teamSport: true,
    positions: [
      'captain',
      'wicketkeeper',
      'slip',
      'gully',
      'point',
      'cover',
      'thirdMan',
      'fineLeg',
      'midWicket',
      'midOff',
      'squareLeg'
    ],
    players: ['Andre Russell', 'Ben Stokes', 'Kane Williamson']
  },
  {
    name: 'soccer',
    icon: 'football',
    teamSport: true,
    teams: teams.soccer,
    positions: [
      'goalkeeper',
      'centerForward',
      'centerbackStopper',
      'centerbackSweeper',
      'centerbackQuarterBack',
      'rightFullback',
      'leftFullback',
      'defensiveMid',
      'defensiveMidBallWinner',
      'defensiveMidDeepLyingPlaymaker',
      'boxToBoxMid',
      'wideMid',
      'attackingMid',
      'rightMid',
      'leftMid',
      'centerMid',
      'striker',
      'wingback',
      'wingers',
      'false9',
      'raumdeuter',
      'forward'
    ]
  },
  {
    name: 'mma',
    icon: 'mma',
    players: ['Conor McGregor', 'Kamaru Usman', 'Israel Adesanya']
  },
  {
    name: 'carRace',
    icon: 'carRace',
    players: ['Max Verstappen', 'Corey LaJoie', 'Sébastien Ogier']
  },
  {
    name: 'tennis',
    icon: 'tennis',
    positions: ['oneUp', 'oneBack']
  },
  {
    name: 'acrobatics'
  },
  {
    name: 'airSports'
  },
  {
    name: 'archery'
  },
  {
    name: 'combatSports'
  },
  {
    name: 'cycling'
  },
  {
    name: 'cueSports'
  },
  {
    name: 'equestrianSports'
  },
  {
    name: 'golf'
  },
  {
    name: 'handball',
    teamSport: true,
    positions: [
      'goalkeeper',
      'leftBack',
      'centerBack',
      'rightBack',
      'leftWinger',
      'centerForward',
      'rightWinger',
      'farRight',
      'halfRight',
      'backCenter',
      'frontCenter'
    ]
  },
  {
    name: 'iceSports'
  },
  {
    name: 'iceHockey',
    teamSport: true,
    positions: [
      'leftDefenseman',
      'goaltender',
      'rightDefenseman',
      'leftWinger',
      'center',
      'rightWinger'
    ]
  },
  {
    name: 'lacrosse',
    teamSport: true,
    positions: ['attackmen', 'mid', 'defensemen', 'goalkeeper']
  },
  {
    name: 'polo',
    teamSport: true,
    positions: [
      'lowWingLeftWing',
      'lowWingRightWing',
      'centerHoleSet',
      'topWingLeftFlat',
      'topWingRightFlat',
      'point',
      'cornerPost',
      'middleDefense',
      'topDefense'
    ]
  },
  {
    name: 'weightlifting'
  },
  {
    name: 'rowing',
    teamSport: true,
    positions: ['coxswain', 'rower']
  },
  {
    name: 'softball',
    teamSport: true,
    positions: [
      'pitcher',
      'catcher',
      'firstBaseman',
      'secondBaseman',
      'shortstop',
      'thirdBaseman',
      'leftFielder',
      'centerFielder',
      'rightFielder'
    ]
  },
  {
    name: 'rugby',
    teamSport: true,
    positions: [
      'looseheadProp',
      'hooker',
      'tightheadProp',
      'lock2ndRow',
      'blindSideFlanker',
      'openSideFlanker',
      'number8',
      'scrumHalf',
      'flyHalf',
      'leftWing',
      'insideCenter',
      'outsideCenter',
      'rightWing',
      'fullback'
    ]
  },
  {
    name: 'volleyball',
    teamSport: true,
    positions: ['setter', 'outsideHitter', 'middleBlocker', 'libero', 'oppositeHitter']
  },
  {
    name: 'coachingMentoring'
  },
  {
    name: 'figureSkating'
  },
  {
    name: 'formula1'
  },
  {
    name: 'gymnastics'
  },
  {
    name: 'hockey'
  },
  {
    name: 'kickboxing'
  },
  {
    name: 'motorSports'
  },
  {
    name: 'muayThai'
  },
  {
    name: 'olympics'
  },
  {
    name: 'poleSports'
  },
  {
    name: 'sportsInfluencer'
  },
  {
    name: 'swimming'
  },
  {
    name: 'trackField'
  },
  {
    name: 'visualArtist'
  },
  {
    name: 'wheelchairRugby'
  },
  {
    name: 'wrestling'
  },
  {
    name: 'alpineSkiing'
  },
  {
    name: 'flagFootball'
  },
  {
    name: 'climbing'
  },
  {
    name: 'badminton'
  },
  {
    name: 'badminton'
  },
  {
    name: 'motorcycleRacing'
  }
];

export default sports;
